import { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/kailospay/logo-blue.png";
import { calcPaymentAmounts } from "../../lib/paymentAmounts";
import "../../styles/payment-preview.css";

export default function PaymentAmountPreview({ start }: { start: string }) {
  const [amount, setAmount] = useState(1000000);
  const { fee, vat, total } = calcPaymentAmounts(amount);
  const won = (value: number) => value.toLocaleString("ko-KR");

  return <section className="jp-amount-preview" aria-label="주류페이 결제 화면 미리보기">
    <div className="jp-amount-preview-brand">
      <img src={logo} alt="주류페이" />
      <span>미리보기</span>
    </div>
    <div className="jp-amount-preview-title">송금 정보</div>
    <ol className="jp-amount-preview-steps" aria-label="결제 화면 예시: 금액·일정 단계">
      <li className="is-done">수취 계좌</li>
      <li className="is-current">금액·일정</li>
      <li>최종 확인</li>
    </ol>
    <h3>얼마를 보낼까요?</h3>
    <div className="jp-amount-preview-value" aria-live="polite">{won(amount)}<span>원</span></div>
    <div className="jp-amount-preview-choices" role="group" aria-label="예시 송금액 선택">
      {[500000, 1000000, 2000000].map(value => <button type="button" key={value} aria-pressed={amount === value} onClick={() => setAmount(value)}>{value / 10000}만원</button>)}
    </div>
    <dl className="jp-amount-preview-totals" aria-live="polite" aria-atomic="true">
      <div><dt>이용료 3.7%</dt><dd>{won(fee)}원</dd></div>
      <div><dt>이용료 부가세</dt><dd>{won(vat)}원</dd></div>
      <div className="jp-amount-preview-total"><dt>총 결제금액</dt><dd>{won(total)}원</dd></div>
    </dl>
    <Link to={start} className="jp-amount-preview-start">결제등록 시작하기</Link>
    <p>예시 금액입니다. 최종 금액은 결제등록 시 확인하세요.</p>
  </section>;
}
